<template>
    <div>
        <div class="container-fluid mt-2 mb-3">
            <div class="row">
                <div class="col-md-6">
                    <div class="card">
                        <div class="card-body">
                            <h5 class="card-title">Subir Archivos</h5>
                            <form enctype="multipart/form-data" @submit.prevent>
                                <div class="mb-3">
                                    <label for="fileInput" class="form-label">Seleccionar archivo</label>
                                    <input type="file" class="form-control" id="fileInput" @change="handleFileChange"
                                        ref="fileInput" />
                                    <small v-if="fileError" class="text-danger">{{ fileError }}</small>
                                </div>

                                <vs-button v-if="userStats !== 1" type="button" @click="uploadFile" :disabled="!selectedFile || fileError"
                                    color="rgb(59,222,200)" gradient block>
                                    💾 Subir archivo
                                </vs-button>


                                <p v-if="uploadStatus">{{ uploadStatus }}</p>

                                <div class="text-center">
                                    <a class="smallText" href="#" @click="fetchFiles">Ver Archivos</a>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div class="col-md-6" v-if="fileList.length > 0">
                    <div class="card">
                        <div class="card-body">
                            <h5>Imágenes:</h5>
                            <ul>
                                <li v-if="fileList.filter(file => file.endsWith('.jpeg') || file.endsWith('.jpg')).length === 0" class="text-muted">
                                    No hay imágenes para mostrar.
                                </li>
                                <li v-for="file in fileList" :key="file"
                                    v-if="file.endsWith('.jpeg') || file.endsWith('.jpg')">
                                    <a href="#" @click.prevent="displayImage(file)">{{ file.split('/').pop() }}</a>
                                </li>
                            </ul>
                            <h5>Archivos:</h5>
                            <ul>
                                <li v-if="fileList.filter(file => file.endsWith('.pdf')).length === 0" class="text-muted">
                                    No hay archivos PDF para mostrar.
                                </li>
                                <li v-for="file in fileList" :key="file" v-if="file.endsWith('.pdf')">
                                    <a href="#" @click.prevent="downloadPdf(file)">{{ file.split('/').pop() }}</a>
                                </li>
                            </ul>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    var config = require("@/config/api.json");
    import Compressor from 'compressorjs';
    import { PDFDocument } from 'pdf-lib';
    const API = config.api;

    export default {
        name: "fileUploader",
        props: {
            currentUser: {
                type: Object,
                required: true
            },
            paciente: {
                type: Object,
                required: true
            },
            consulta_id: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                isProcessing: false,
                selectedFile: null,
                fileError: null,
                uploadStatus: "",
                currentUser: { mainId: 456 },
                fileList: [],
                myAPI: API,
                userStats: null,
            };
        },
        mounted() {
            this.fetchFiles();
            setTimeout(() => {
                this.userStats = this.getUserStatus();
            }, 500);
        },

        methods: {
            handleFileChange(event) {
                const file = event.target.files[0];
                if (!file) {
                    this.fileError = "Debes seleccionar un archivo.";
                    this.selectedFile = null;
                    return;
                }

                const allowedTypes = ["image/png", "image/jpeg", "application/pdf"];
                if (!allowedTypes.includes(file.type)) {
                    this.fileError = "Solo se permiten archivos JPG, PNG o PDF.";
                    this.selectedFile = null;
                    return;
                }

                // Validar tamaño del archivo PDF
                if (file.type === "application/pdf" && file.size > 5 * 1024 * 1024) {
                    this.fileError = "El archivo PDF no debe exceder los 5 MB.";
                    setTimeout(() => {
                        this.resetForm(); // Limpiar el formulario
                    }, 6000);
                    return;
                }
                // Validar tamaño del archivo JPG/PNG
                if ((file.type === "image/png" || file.type === "image/jpeg") && file.size > 10 * 1024 * 1024) {
                    this.fileError = "Las imágenes JPG o PNG no deben exceder los 10 MB.";
                    setTimeout(() => {
                        this.resetForm(); // Limpiar el formulario
                    }, 6000);
                    return;
                }

                if (file.type === "application/pdf") {
                    console.log("Antes de comprimir PDF:", file.size / 1024, "KB");
                    const reader = new FileReader();

                    reader.onload = async (e) => {
                        try {
                            const pdfDoc = await PDFDocument.load(e.target.result);

                            // Opcional: Eliminar datos innecesarios
                            pdfDoc.setProducer('');
                            pdfDoc.setCreator('');
                            pdfDoc.setTitle('');

                            // Guardar el PDF optimizado
                            const compressedPdfBytes = await pdfDoc.save({ useObjectStreams: true });

                            const compressedFile = new Blob([compressedPdfBytes], { type: "application/pdf" });
                            compressedFile.name = file.name; // Asignar el nombre original al archivo comprimido

                            this.selectedFile = compressedFile;
                            this.fileError = null;
                            console.log("Después de comprimir PDF:", compressedFile.size / 1024, "KB");
                        } catch (err) {
                            console.error("Error al comprimir el archivo PDF:", err);
                            this.fileError = "Error al comprimir el archivo PDF.";
                            this.selectedFile = null;
                        }
                    };

                    reader.readAsArrayBuffer(file);
                } else if (file.type === "image/png" || file.type === "image/jpeg") {
                    console.log("Antes de comprimir:", file.size / 1024, "KB");

                    if (file.type === "image/png") {
                        const canvas = document.createElement("canvas");
                        const img = new Image();
                        const reader = new FileReader();

                        reader.onload = (e) => {
                            img.onload = () => {
                                canvas.width = img.width;
                                canvas.height = img.height;
                                const ctx = canvas.getContext("2d");
                                ctx.drawImage(img, 0, 0);
                                canvas.toBlob(
                                    (blob) => {
                                        blob.name = file.name;
                                        new Compressor(blob, {
                                            quality: 0.4,
                                            success: (compressedFile) => {
                                                compressedFile.name = file.name;
                                                this.selectedFile = compressedFile;
                                                this.fileError = null;
                                                console.log("Después de comprimir:", compressedFile.size / 1024, "KB");
                                            },
                                            error: (err) => {
                                                console.error("Error al comprimir el archivo:", err);
                                                this.fileError = "Error al comprimir el archivo.";
                                                this.selectedFile = null;
                                            },
                                        });
                                    },
                                    "image/jpeg",
                                    0.8
                                );
                            };
                            img.src = e.target.result;
                        };
                        reader.readAsDataURL(file);
                    } else {
                        new Compressor(file, {
                            quality: 0.4,
                            success: (compressedFile) => {
                                compressedFile.name = file.name;
                                this.selectedFile = compressedFile;
                                this.fileError = null;
                                console.log("Después de comprimir:", compressedFile.size / 1024, "KB");
                            },
                            error: (err) => {
                                console.error("Error al comprimir el archivo:", err);
                                this.fileError = "Error al comprimir el archivo.";
                                this.selectedFile = null;
                            },
                        });
                    }
                } else {
                    this.selectedFile = file;
                    this.fileError = null;
                }
            },
            resetForm() {
                this.selectedFile = null;
                this.fileError = null;
                this.$refs.fileInput.value = ""; // Resetear el input de archivo
            },
            getFileIcon(fileName) {
                if (!fileName) {
                    return 'insert_drive_file'; // Icono predeterminado si no hay nombre de archivo
                }
                const extension = fileName.split('.').pop().toLowerCase();
                switch (extension) {
                    case 'jpg':
                    case 'jpeg':
                        return 'image'; // Material icon for images
                    case 'pdf':
                        return 'picture_as_pdf'; // Material icon for PDFs
                    default:
                        return 'insert_drive_file'; // Default icon for files
                }
            },
            async uploadFile() {
                if (!this.selectedFile) {
                    this.uploadStatus = "Selecciona un archivo antes de subirlo.";
                    return;
                }

                console.log("Datos antes de enviar:", {
                    consulta_id: this.consulta_id,
                    personal_medico_id: this.currentUser.mainId,
                    file: this.selectedFile
                });

                const formData = new FormData();
                formData.append("file", this.selectedFile);
                formData.append("consulta_id", this.consulta_id);
                formData.append("personal_medico_id", this.currentUser.mainId);

                try {
                    const response = await axios.post(`${API}/subirArchivos`, formData, {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    });

                    if (response.data.status === "success") {
                        console.log("Archivo subido exitosamente:", response.data);

                        await this.callAudit(this.consulta_id, "CREAR", "archivos", this.consulta_id, `Se sube archivo: ${this.selectedFile.name} en notas médicas`);

                        this.uploadStatus = "Archivo subido exitosamente.";
                        setTimeout(() => {
                            this.uploadStatus = "";
                        }, 6000);
                        this.resetForm(); // Llamar al método para resetear el formulario
                        this.fetchFiles()
                    } else {
                        this.uploadStatus = `Error: ${response.data.message || "Error desconocido"}`;
                    }
                } catch (error) {
                    console.error("Error al subir el archivo:", error);
                    this.uploadStatus = "Error al subir el archivo.";
                }
            },
            downloadPdf(file) {
                const pdfUrl = `${this.myAPI}${file}`;
                const modal = document.createElement("div");
                modal.style.position = "fixed";
                modal.style.top = "0";
                modal.style.left = "0";
                modal.style.width = "100%";
                modal.style.height = "100%";
                modal.style.backgroundColor = "rgba(0, 0, 0, 0.8)";
                modal.style.display = "flex";
                modal.style.justifyContent = "center";
                modal.style.alignItems = "center";
                modal.style.zIndex = "1000";

                const iframe = document.createElement("iframe");
                iframe.src = pdfUrl;
                iframe.style.width = "80%";
                iframe.style.height = "80%";
                iframe.style.border = "2px solid white";
                iframe.style.borderRadius = "10px";

                const closeButton = document.createElement("span");
                closeButton.textContent = "✖";
                closeButton.style.position = "absolute";
                closeButton.style.top = "20px";
                closeButton.style.right = "20px";
                closeButton.style.color = "white";
                closeButton.style.fontSize = "24px";
                closeButton.style.cursor = "pointer";
                modal.style.zIndex = "1050"; // Asegurarse de que el modal esté al frente
                closeButton.addEventListener("click", () => {
                    document.body.removeChild(modal);
                });

                modal.appendChild(iframe);
                modal.appendChild(closeButton);
                document.body.appendChild(modal);
            },
            displayImage(file) {
                const imageUrl = `${this.myAPI}${file}`;
                const modal = document.createElement("div");
                modal.style.position = "fixed";
                modal.style.top = "0";
                modal.style.left = "0";
                modal.style.width = "100%";
                modal.style.height = "100%";
                modal.style.backgroundColor = "rgba(0, 0, 0, 0.8)";
                modal.style.display = "flex";
                modal.style.justifyContent = "center";
                modal.style.alignItems = "center";
                modal.style.zIndex = "1000";

                const img = document.createElement("img");
                img.src = imageUrl;
                img.style.maxWidth = "90%";
                img.style.maxHeight = "90%";
                img.style.border = "2px solid white";
                img.style.borderRadius = "10px";

                const closeButton = document.createElement("span");
                closeButton.textContent = "✖";
                closeButton.style.position = "absolute";
                closeButton.style.top = "20px";
                closeButton.style.right = "20px";
                closeButton.style.color = "white";
                closeButton.style.fontSize = "24px";
                closeButton.style.cursor = "pointer";
                modal.style.zIndex = "1050"; // Asegurarse de que el modal esté al frente

                closeButton.addEventListener("click", () => {
                    document.body.removeChild(modal);
                });

                modal.appendChild(img);
                modal.appendChild(closeButton);
                document.body.appendChild(modal);
            },
            async fetchFiles() {
                // Si ya se está procesando, no permitir otro clic
                if (this.isProcessing) return;

                // Marcar que la solicitud está en progreso
                this.isProcessing = true;

                try {
                    // Hacer la solicitud
                    const response = await axios.get(`${API}/listarArchivos`, {
                        params: {
                            consulta_id: this.consulta_id,
                            personal_medico_id: this.currentUser.mainId
                        }
                    });

                    if (response.data.status === "success") {
                        this.fileList = response.data.files; // Almacenar la lista de archivos
                        console.log("Archivos obtenidos:", this.fileList);
                    } else {
                        this.notify('info', "No hay archivos para mostrar");
                    }
                } catch (error) {
                    console.error("Error al consumir el endpoint /listarArchivos:", error);
                    this.notify('info', "No hay archivos para mostrar");
                } finally {
                    // Asegurarse de que la bandera se resetee después de procesar la solicitud
                    this.isProcessing = false;
                }
            },
        }
    };
</script>

<style>
    .card {
        margin-top: 20px;
    }

    .card-body {
        line-height: 1.6;
    }

    .card-footer {
        font-size: 0.9rem;
    }

    .material-icons {
        font-size: 24px;
        vertical-align: middle;
    }

    .vs-dialog-content {
        z-index: 1050 !important;
    }
</style>